<template>
	<div>
		<div class="row">
			<div class="col-lg-12 mb-3">
				<b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
				<b-card :header="$t('general.line_list.revision.title')" header-tag="h3" class="bg-default-card">
					<revision-control-table ref="rt"
                        actionWidth='90px' 
                        @pressEdit="onEditRow"
                        @pressDelete="onDeleteRow"
                        @pressAdd="onAddRow"
                        @pressReturn="onReturn">
						<span slot="return">
							{{$t('general.buttons.return_to.return_to_line_list')}}
						</span>
						<span slot="add">
							{{ $t('general.revision.create_button') }}
						</span>
					</revision-control-table>
				</b-card>
			</div>
		</div>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="editModal" :title="actionTitle" size="lg" @ok="saveAction" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_revisions'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.line_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.line_number">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.area') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.area">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.fluid') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.fluid">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.process_code') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.process_code">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.serial_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.serial_no">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.line_class') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.line_class">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.line_size') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.line_size">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pipe_material') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.pipe_material">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.tie_in_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.tie_in_no">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.location_from') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.location_from">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.location_to') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.location_to">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.operating_press') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" maxlength="50" class="form-control" v-model="model.operating_press">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.operating_temp') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" maxlength="50" class="form-control" v-model="model.operating_temp">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.design_press') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.design_press">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.design_temp') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" maxlength="50" class="form-control" v-model="model.design_temp">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.testing_press') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" maxlength="50" class="form-control" v-model="model.testing_press">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.testing_med') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.testing_med">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.insulation_or_tracing_type') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.insulation_or_tracing_type">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.insulation_or_tracing_thickness') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.insulation_or_tracing_thickness">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.insulation_or_tracing_medium') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.insulation_or_tracing_medium">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.nde_extent_rt') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.nde_extent_rt">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.nde_extent_mt') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.nde_extent_mt">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.nde_extent_ut') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.nde_extent_ut">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.nde_extent_others') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.nde_extent_others">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.nde_extent_pt') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.nde_extent_pt">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.painting_code') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.painting_code">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.painting_thickness') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.painting_thickness">
                        </div>
                    </div>
                    
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pwht') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <toggle-button v-model="model.pwht" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.visual_test') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.visual_test">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.remarks') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="4" type="text" maxlength="255" class="form-control" v-model="model.remarks"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.p_and_id_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.p_and_id_no">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.ped_category') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.ped_category">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.ped_module_or_hazard') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.ped_module_or_hazard">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.fluid_phase') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.fluid_phase">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.test_circuit_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.test_circuit_no" name="test_circuit_no" id="test_circuit_no" data-vv-as="test circuit no" ref="test_circuit_no">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.cleaning') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.cleaning">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.note_1') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.note_1"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.note_2') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.note_2"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.revision_date"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input class="form-control" type="text" disabled v-model="model.revision_number">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_description') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.revision_description"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_reason') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.revision_reason_setting"
                                :options="currentReason"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isReasonLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="value" track-by="id"
                                :selectLabel="''"
                                @search-change="onReasonSearch"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.revision_reason_setting != null && typeof model.revision_reason_setting.id != 'undefined' && model.revision_reason_setting.id != null"  
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedProjectSetting"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_remarks') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.revision_remarks"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

		<revision-control-modal :model.sync="this.model" ref="addModal" :title="actionTitle" settingType="reason_for_revision" @ok="saveAction"/>

		<confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
			{{ $t('messages.delete') }}
		</confirm-dialog>
	</div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import miniToastr from 'mini-toastr';
import _ from 'lodash';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Multiselect from 'vue-multiselect';

import RevisionControlModal from '@/components/global/modals/RevisionControlModal.vue';
import RevisionControlTable from '@/components/global/tables/RevisionControlTable.vue';

export default {
	name: 'line_list_revisioncontrol',
	components: {
		DataTable,
		ConfirmDialog,
		Multiselect,
		flatPickr,
		RevisionControlModal,
		RevisionControlTable,
	},
	data() {
		return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/'
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.line_list.title'),
                    active: true
                },
                {
					text: Vue.i18n.translate('general.revision.title'),
					active: true
				}
            ],
            model: {
                line_number: null,
                project_id: null,
                area: null,
                fluid: null,
                process_code: null,
                serial_no: null,
                line_class: null,
                line_size: null,
                pipe_material: null,
                tie_in_no: null,
                location_from: null,
                location_to: null,
                operating_press: null,
                operating_temp: null,
                design_press: null,
                design_temp: null,
                testing_press: null,
                testing_med: null,
                insulation_or_tracing_type: null,
                insulation_or_tracing_thickness: null,
                insulation_or_tracing_medium: null,
                nde_extent_rt: null,
                nde_extent_mt: null,
                nde_extent_ut: null,
                nde_extent_others: null,
                nde_extent_pt: null,
                painting_code: null,
                painting_thickness: null,
                pwht: null,
                visual_test: null,
                remarks: null,
                p_and_id_no: null,
                ped_category: null,
                ped_module_or_hazard: null,
                fluid_phase: null,
                test_circuit_no: null,
                cleaning: null,
                note_1: null,
                note_2: null,
                rev: null,

                revision_number: null,
				revision_date: null,
				revision_description: null,
				revision_reason: null,
				revision_remarks: null,
				revision_reason_setting: null,
            },

		    currentReason: [],
            isReasonLoading: false,

            row: null,
            actionTitle: null,
            tableNameTranslated: Vue.i18n.translate('general.revision.main_title'),
        }
	},
	computed: {
        tie_in_types: {
            get: function () {
                let tie_in_types = this.$store.getters.getTieInTypes;
                return tie_in_types;
            }
        },
		priorities: {
            get: function () {
                let priorities = this.$store.getters.getDrawingPriority;
                return priorities;
            }
        }
    },
    watch: {
        tie_in_types: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
		priorities: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
	mounted() {
		this.$refs.rt.load('line?project_id='+this.$route.params.id+'&filters[parent_line_id]='+ this.$route.params.id2);
	},
	methods: {
		successMsg(msg) {
			miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
		},
		errorMsg(msg) {
			miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
		},
        async onAddRow() {
			this.row = null;
			this.model.revision_remarks = null;
			this.model.revision_reason = null;
			this.model.revision_reason_setting = null;
			this.model.revision_description = null;
			this.model.revision_date = null;

			this.actionTitle = Vue.i18n.translate('general.revision.create_button');
			await this.findLastRevisionNumber('line/'+this.$route.params.id2+'/maxrevision?project_id='+this.$route.params.id);
			this.$refs.addModal.show();
		},
		onEditRow(row) {
			this.actionTitle = Vue.i18n.translate('general.revision.edit_button');
            this.currentReason = [];

			this.row = row;
			this.model.line_number = this.row.line_number;
            this.model.project_id = this.row.project_id;
            this.model.area = this.row.area;
            this.model.fluid = this.row.fluid;
            this.model.process_code = this.row.process_code;
            this.model.serial_no = this.row.serial_no;
            this.model.line_class = this.row.line_class;
            this.model.line_size = this.row.line_size;
            this.model.pipe_material = this.row.pipe_material;
            this.model.tie_in_no = this.row.tie_in_no;
            this.model.location_from = this.row.location_from;
            this.model.location_to = this.row.location_to;
            this.model.operating_press = this.row.operating_press;
            this.model.operating_temp = this.row.operating_temp;
            this.model.design_press = this.row.design_press;
            this.model.design_temp = this.row.design_temp;
            this.model.testing_press = this.row.testing_press;
            this.model.testing_med = this.row.testing_med;
            this.model.insulation_or_tracing_type = this.row.insulation_or_tracing_type;
            this.model.insulation_or_tracing_thickness = this.row.insulation_or_tracing_thickness;
            this.model.insulation_or_tracing_medium = this.row.insulation_or_tracing_medium;
            this.model.nde_extent_rt = this.row.nde_extent_rt;
            this.model.nde_extent_mt = this.row.nde_extent_mt;
            this.model.nde_extent_ut = this.row.nde_extent_ut;
            this.model.nde_extent_others = this.row.nde_extent_others;
            this.model.nde_extent_pt = this.row.nde_extent_pt;
            this.model.painting_code = this.row.painting_code;
            this.model.painting_thickness = this.row.painting_thickness;
            this.model.pwht = Boolean(this.row.pwht);
            this.model.visual_test = this.row.visual_test;
            this.model.remarks = this.row.remarks;
            this.model.p_and_id_no = this.row.p_and_id_no;
            this.model.ped_category = this.row.ped_category;
            this.model.ped_module_or_hazard = this.row.ped_module_or_hazard;
            this.model.fluid_phase = this.row.fluid_phase;
            this.model.test_circuit_no = this.row.test_circuit_no;
            this.model.cleaning = this.row.cleaning;
            this.model.note_1 = this.row.note_1;
            this.model.note_2 = this.row.note_2;
            this.model.rev = this.row.rev;

			this.model.revision_number = row.revision_number;
			this.model.revision_remarks = row.revision_remarks;
			this.model.revision_reason = row.revision_reason;
			this.model.revision_description = row.revision_description;
			this.model.revision_reason_setting = row.revision_reason_setting;
            
			this.model.revision_date = row.revision_date;

			this.$refs.editModal.show();
		},
		saveAction(e) {
            e.preventDefault();

            if (this.model.revision_reason_setting == null) {
                this.model.revision_reason_setting = { 'id': null }
            }

            let data = {
                line_number: this.model.line_number,
                project_id: this.$route.params.id,
                area: this.model.area,
                fluid: this.model.fluid,
                process_code: this.model.process_code,
                serial_no: this.model.serial_no,
                line_class: this.model.line_class,
                line_size: this.model.line_size,
                pipe_material: this.model.pipe_material,
                tie_in_no: this.model.tie_in_no,
                location_from: this.model.location_from,
                location_to: this.model.location_to,
                operating_press: this.model.operating_press,
                operating_temp: this.model.operating_temp,
                design_press: this.model.design_press,
                design_temp: this.model.design_temp,
                testing_press: this.model.testing_press,
                testing_med: this.model.testing_med,
                insulation_or_tracing_type: this.model.insulation_or_tracing_type,
                insulation_or_tracing_thickness: this.model.insulation_or_tracing_thickness,
                insulation_or_tracing_medium: this.model.insulation_or_tracing_medium,
                nde_extent_rt: this.model.nde_extent_rt,
                nde_extent_mt: this.model.nde_extent_mt,
                nde_extent_ut: this.model.nde_extent_ut,
                nde_extent_others: this.model.nde_extent_others,
                nde_extent_pt: this.model.nde_extent_pt,
                painting_code: this.model.painting_code,
                painting_thickness: this.model.painting_thickness,
                pwht: this.model.pwht,
                visual_test: this.model.visual_test,
                remarks: this.model.remarks,
                p_and_id_no: this.model.p_and_id_no,
                ped_category: this.model.ped_category,
                ped_module_or_hazard: this.model.ped_module_or_hazard,
                fluid_phase: this.model.fluid_phase,
                test_circuit_no: this.model.test_circuit_no,
                cleaning: this.model.cleaning,
                note_1: this.model.note_1,
                note_2: this.model.note_2,
                rev: this.model.rev,

                revision_number: this.model.revision_number,
                revision_remarks: this.model.revision_remarks,
                revision_reason: this.model.revision_reason_setting.id,
                revision_description: this.model.revision_description,
                revision_date: this.model.revision_date,
                from_revision_control: 1,
            }

            Object.keys(data).forEach(key => {
                if (data[key] === '') {
                    data[key] = null;
                }
            });

            if (this.row) {
                data['date'] = data.date ? data.date : null;
                data['id'] = this.$route.params.id2;
                http.route('line/' + this.row.id).patch(data, true).then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        this.$refs.rt.refresh();
                        this.$refs.editModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            } else {
                data['id'] = this.$route.params.id2;
                http.route("line").post(data, true).then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                        let id = response.data.id;
                        this.$refs.rt.refresh();
                        this.$refs.addModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
		},
        onDeleteRow(row, index) {
			this.actionTitle = Vue.i18n.translate('general.revision.delete_button');
			this.row = row;
			this.$refs.deleteModal.show();
		},
		deleteAction (button) {
			if (button == 1) {
				let data = http.route('line/' + this.row.id).delete();
				data.then(response => {
					if (!response.isError) {
						this.$refs.rt.refresh(-1);
						this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
					} else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
				});
			}
			this.$refs.deleteModal.hide();
		},
		findLastRevisionNumber(request) {
			return new Promise(resolve => {
				http.route(request).get().then(response => {
                    if (!response.isError) {
					    this.model.revision_number = response.data+1;
                    } else {
					    this.model.revision_number = null;
					}
					resolve(this.model.revision_number);
				});
			});
		},
        onReturn() {
			this.$router.push({name: 'line_list', params: {id:this.$route.params.id}});
		},
        onReasonSearch(search) {
            if (search == '') {
                this.currentReason = [];
                
                return false;
            }

            this.isReasonLoading = true;
            this.searchReason(search, this);
		},
		searchReason: _.debounce((search, vm) => {
			let data = http.route("projectsetting?project_id="+vm.$route.params.id+"&filters[type]=reason_for_revision&get_all=1&search_select=" + search).get();
			data.then(response => {
                if (response.data != false) {
                    vm.currentReason = response.data;
                }
                vm.isReasonLoading = false;
			});
		}, 500),
        clearSelectedProjectSetting () {
			this.model.revision_reason_setting = null;
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/line_list/line_list_revisioncontrol.vue